import React from "react";
import { Grid, Typography } from "@material-ui/core";
import AdSummeryListitem from "../../components/ad-summery-list-item";
import { API_STATUSES } from "../..";
import { isEmpty } from "lodash";
import { Skeleton } from "@material-ui/lab";
import { useContext } from "react";
import { UserListContext } from "../../../../../../context/follow-up-widgets";

const SkeletonView = () => {
  return (
    <Grid
      container
      style={{ backgroundColor: "#f2f2f2", padding: 16, columnGap: 16 }}
    >
      <Skeleton variant="circle" width={40} height={40} animation="wave" />
      <Grid container xs className="gap-y-8">
        <Skeleton variant="rect" height={60} width={"100%"} animation="wave" />
        <Skeleton variant="rect" height={20} width={"100%"} animation="wave" />
      </Grid>
    </Grid>
  );
};

const AdSummeryListView = () => {
  const { results, responseStatus } = useContext(UserListContext);

  return (
    <Grid
      container
      direction="column"
      style={{
        paddingBlock: 32,
        rowGap: 16,
      }}
    >
      {responseStatus !== API_STATUSES.PENDING &&
        results.map((advertisement) => (
          <AdSummeryListitem
            key={advertisement.id}
            advertisement={advertisement}
          />
        ))}

      {responseStatus === API_STATUSES.PENDING && (
        <Grid container direction="column" className="gap-y-16">
          <SkeletonView />
          <SkeletonView />
          <SkeletonView />
          <SkeletonView />
          <SkeletonView />
          <SkeletonView />
        </Grid>
      )}
      {responseStatus === API_STATUSES.SUCCESS && isEmpty(results) && (
        <Typography variant="body2">No results found</Typography>
      )}
    </Grid>
  );
};

export default AdSummeryListView;
